import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {PractitionerCareTeamInput, PractitionerCareTeamRoleMap} from "../domain";
import {SimpleDropdown} from "common";

type CareTeamRoleInputProps = {
    sending: boolean;
};
export const PractitionerCareTeamRoleInput = memo(({sending}: CareTeamRoleInputProps) => {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<PractitionerCareTeamInput>();

    return (
        <div>
            <div className="flex text-black-200 pb-2 items-center text-base">
                <div className="w-2/6 text-right">
                    Role
                </div>
                <div className="ml-4 flex items-center">
                    <Controller
                        name="memberRole"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={PractitionerCareTeamRoleMap}
                                selected={value}
                                disabled={sending}
                                hasErrorBorder={errors.memberRole !== undefined}
                                setSelected={(selected) => {
                                    setValue("memberRole", selected);
                                    clearErrors("memberRole");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>
            {
                errors.memberRole &&
                <div className="flex">
                    <div className="w-2/6"/>
                    <div className="ml-4 text-red-700">
                        Please select “Role” before submitting the care team
                    </div>
                </div>
            }
        </div>
    );
});
